// // Sweet Alert1
// // -----------------------------------
import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js'
// import 'sweetalert2/src/sweetalert2.scss'
window.Swal = Swal;
function initSweetAlert() {
    
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success mr-2',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false,
      position: 'center',
    })    
    
    $('[data-sweet-swal]').on('click', function(e) {
        var $link = $(this);
        const message = this.getAttribute('data-sweet-swal');
        const warning_text = this.getAttribute('data-warning-text');        
        e.preventDefault();
        e.stopPropagation();
        
        swalWithBootstrapButtons.fire({
            title: message,
            text: warning_text,
            // type: 'warning',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            showLoaderOnConfirm: false,
            preConfirm: false,
        }).then(function(result) {
            if (result.value) {
                $link.unbind('click');
                e.currentTarget.click();
            }
        });
    });
    
    const swalWithBootstrapDangerButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger mr-2',
        cancelButton: 'btn btn-success'
      },
      buttonsStyling: false,
      position: 'center',
      
    })        
    
    $('[data-danger-swal]').on('click', function(e) {
        var $link = $(this);
        const message = this.getAttribute('data-danger-swal');
        const warning_text = this.getAttribute('data-warning-text');        
        e.preventDefault();
        e.stopPropagation();
        
        swalWithBootstrapDangerButtons.fire({
            title: message,
            text: warning_text,
            // type: 'warning',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            showLoaderOnConfirm: false,
            preConfirm: false,
        }).then(function(result) {
            if (result.value) {
                $link.unbind('click');
                e.currentTarget.click();
            }
        });
    });    
}

export default initSweetAlert;
